import { Handle, Position } from "reactflow";
import { ForLoop, InterpType } from "../../interpretation/interpretable";
import { useInterpretable } from "../flowchart";
import assert from "assert";

export function ForLoop({ data }: { data: string }) {
  const [fornode] = useInterpretable<ForLoop>(data);

  if (!fornode) {
    // I believe a rerender is triggered when:
    // the internal assignment context map has changed,
    // the node's uuid has changed.
    // as such this is a problem as we have multiple rerenders. debugging needed to prevent this.
    console.log("fornode none?");
    return <></>;
  }

  assert(fornode.type == InterpType.ForLoop);

  return (
    <div>
      <Handle type="target" position={Position.Bottom} id={Position.Bottom}></Handle>
      <Handle type="target" position={Position.Top} id={Position.Top}></Handle>
      <Handle type="target" position={Position.Left} id={Position.Left}></Handle>
      <Handle type="target" position={Position.Right} id={Position.Right}></Handle>
      <Handle type="source" position={Position.Bottom} id={Position.Bottom}></Handle>
      <Handle type="source" position={Position.Top} id={Position.Top}></Handle>
      <Handle type="source" position={Position.Left} id={Position.Left}></Handle>
      <Handle type="source" position={Position.Right} id={Position.Right}></Handle>
      <div className="ifnode">
        <span style={{ textAlign: "center" }}>For</span>
      </div>
    </div>
  );
}
